module.exports = __webpack_public_path__ + "img/y4.40907a4f.png";